import { ClientEvents } from 'common/events/ClientEvents';
import { NavClickElementName } from 'common/events/ClientTypes';
import React from 'react';
import { useShowLoginOrSignUpModal } from 'src/auth/modal/useShowLoginOrSignUpModal';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useLocation } from 'src/shared/hooks/useLocation';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';
import { getLogoutRedirectViaLocation, locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { Modal, ModalType } from 'web-common/src/shared/design-system/components/Modal';
import { AccountSettingsModalContent } from './components/AccountSettingsModalContent';

interface AccountSettingsModalProps {
  isShowing: boolean;
  hide: () => void;
}

export const AccountSettingsModal: React.FC<AccountSettingsModalProps> = ({ isShowing, hide }) => {
  const location = useLocation();
  const isLoginOrRegisterPage = locationInRoutes(location, [Routes.CONSUMER_REGISTER, Routes.CONSUMER_LOGIN]);
  const tracker = useTracker();
  const history = useHistory();

  const { show: showLoginModal } = useShowLoginOrSignUpModal();
  const openLoginModal = (eventElementName: NavClickElementName) => (event: React.MouseEvent) => {
    if (isLoginOrRegisterPage) {
      event.preventDefault();
    } else {
      showLoginModal();
      hide();
    }
    tracker.track(ClientEvents.NAV_CLICK, { elementName: eventElementName });
  };

  const logOut = () => {
    tracker.track(ClientEvents.NAV_CLICK, { elementName: 'log-out' });
    history.push(getLogoutRedirectViaLocation(location));
    hide();
  };

  return (
    <Modal isShowing={isShowing} onClose={hide} modalType={ModalType.DOCKED}>
      <AccountSettingsModalContent hide={hide} onLoginClick={openLoginModal('log-in')} onLogOutClick={logOut} />
    </Modal>
  );
};
